module.exports = __webpack_public_path__ + "img/spot-the-signs.d6cbd9a4.jpg";